import {BaseView} from '../core/view';
import constants from './constants';
import { ApiUtil } from '../utils/api-util';
import { TrackingUtil } from '../utils/tracking';
import {JSErrorTracking} from '../utils/js-error-tracking';
import FilterListView from './filter-list-view';
import { MobileUtil } from '../utils/mobile';
import FilterPriceView from './filter-price-view';

export default BaseView.extend({

    el: '[data-bind=filters]',
    urlParams: undefined,

    templates: {
        FILTER_TEMPLATE: require("./templates/filter-list-template.hbs"),
        SORT_TEMPLATE: require("./templates/sort-list-template.hbs")
    },

    events: {
        'click .js-sorting-open': 'loadSortByFilters',
        'click [data-bind=brand-filter]': 'handleSearchableFilter',
        'click [data-bind=shop-filter]': 'handleSearchableFilter',
        'click [data-bind=initialize-filters]': 'feedFiltersWithData',
        'click [data-track=filter]': 'throwFilterEvent',
        'click .js-checkbox-filter' : 'onClickTriggerCheckbox'
    },

    throwFilterEvent: function(e){
        const item = e.currentTarget;
        const filterName = item.getAttribute("data-filter-name");
        if(!item.closest(".js-filter-button-parent").classList.contains("active")) {
            TrackingUtil.throwGAEvent(constants.TRACK_FILTER_USAGE, filterName, '', false);
        }
    },

    handleSearchableFilter: function(e) {
        let inputElement = this.$el.find('[data-bind=' + this.$el.find(e.currentTarget).data('bind') + '-input]');

        this.feedFiltersWithData();

        if (!MobileUtil.isTouch()) {
        	setTimeout(function() {
        		if (inputElement !== undefined) {
        			inputElement.focus();
        		}
            }, 300);
        }
    },
    
    trackFiltersView: _.once(function() {
        TrackingUtil.throwGAEvent(constants.TRACK_MOBILE_SEARCH_BAR, 'Old Filter View', '', false);
    }),
    
    trackCategoriesView: _.once(function() {
        TrackingUtil.throwGAEvent(constants.TRACK_MOBILE_SEARCH_BAR, 'Old Category View', '', false);
    }),

    feedFiltersWithData: _.once(function() {
        let self = this;
        ApiUtil.request({
            path: constants.FILTER_REQUEST_DATA_URL + '?' + self.urlParams,
            success: function(data) {
                if (data.length>0){
                    JSErrorTracking.sendCustomError("Filter API Error - Data is empty");
                }
                self.initializeFilter(data.filters.colors, '[data-bind=color-filter-list]');
                self.initializeFilter(data.filters.patterns, '[data-bind=pattern-filter-list]');
                self.initializeFilter(data.filters.styles, '[data-bind=style-filter-list]');
                self.initializeFilter(data.filters.sizes, '[data-bind=size-filter-list]');
                self.initializeFilter(data.filters.occasions, '[data-bind=occasion-filter-list]');
                self.initializeFilter(data.filters.materials, '[data-bind=material-filter-list]');
                self.initializeFilter(data.filters.brands, '[data-bind=brand-filter-list]');
                self.initializeFilter(data.filters.rooms, '[data-bind=room-filter-list]');
                self.initializeFilter(data.filters.sunProtectionLevels, '[data-bind=sunprotection-filter-list]');
                self.initializeFilter(data.filters.scents, '[data-bind=scent-filter-list]');
                self.initializeFilter(data.filters.ingredients, '[data-bind=ingredient-filter-list]');
                self.initializeFilter(data.filters.effects, '[data-bind=effect-filter-list]');
                self.initializeFilter(data.filters.applications, '[data-bind=application-filter-list]');
                self.initializeFilter(data.filters.specialities, '[data-bind=speciality-filter-list]');
                self.initializeShopFilters(data.filters.shops);

                // initialize handling of dropdown lists
                self.$el.find('.filters-tab .detail').each(function(i, el) {
                    return new FilterListView({el : el});
                });
                
                new FilterPriceView(data.filters.price, data.filters.freeShipping, data.filters.sale);
            },
            error: function(xhr){
                JSErrorTracking.sendCustomError("Filter API Error - URL not found - status:"+xhr.status);
            }
        });
    }),

    initializeFilter: function(data, bind) {
    	if(data !== undefined){
            const self = this;

    	    let code = '';

            $.each(data, function(i, val) {
                code += self.templates.FILTER_TEMPLATE({
                    searchname: val.name.toLowerCase(),
                    name: val.name,
                    url: val.url,
                    active: val.active,
                    colorId: val.colorId
                });
            });
            this.$el.find(bind).html(code);
    	} else {
            JSErrorTracking.sendCustomError("Filter API Error - Data "+bind+" is empty");
        }
    },
    
    initializeShopFilters: function(data) {
        const self = this;
        const premiumHeadline = '<strong class="premium-filter-headline">' + getI18N(jlocale.premiumShops) + '</strong><br/>';
        const regularHeadline = '<strong class="premium-filter-headline">' + getI18N(jlocale.allShops) + '</strong><br/>';

        let code = '';
        let hasPremium = false;
        let firstNotPremium = true;
        let showPremium = true;
            
        if (data !== undefined) {
            
        	$.each(data, function(i, val) {
            	const data = {
            		searchname: val.name.toLowerCase(),
            		name: val.name,
            		url: val.url,
            		active: val.active,
            		premium: val.premium
            	};
            	
            	if (val.premium && showPremium) {
                    data['type'] = premiumHeadline;
                    showPremium = false;
                }

                if (hasPremium && !val.premium && firstNotPremium) {
                    data['type'] = regularHeadline;
                    data['addClass'] = 'first-not-premium';
                    firstNotPremium = false;
                }
        		
                if (!hasPremium && val.premium) {
                    hasPremium = true;
                }
            	
            	code += self.templates.FILTER_TEMPLATE(data);
            });

            this.$el.find('[data-bind=search-shop-list]').html(code);
        
        } else {
            JSErrorTracking.sendCustomError("Filter API Error - Data shop-filter is empty");
        }
    },

    loadSortByFilters: _.once(function(e) {
        let self = this;
        let commentedSortByFilterLinks = this.$el.find(e.currentTarget).parent().find('ul.list');

        $.get(constants.GET_SORT_BY_LIST_API_URL + encodeURIComponent(this.urlParams), function(data) {
            let code = "";
            
            $.each(data.options, function(i, val) {
                code += self.templates.SORT_TEMPLATE({
                    name: val.name,
                    url: val.url,
                    active: val.active,
                });
            });
            commentedSortByFilterLinks.html(code);
        });
    }),

    initialize: function() {
        this.urlParams = $('#searchfeed').data('active-querystring');
    },

    onClickTriggerCheckbox: function(e) {
        
        var current = this.$el.find(e.currentTarget);
        current.toggleClass('checkbox-active');

        let action = '';
        let filterType = '';
        let filterValue = current.hasClass('checkbox-active');

        if(current.attr('data-filter') === constants.FILTER_SALE_CHECKBOX_NAME) {
            action = 'FilterSale';
            filterType = 'sale';
        } else if(current.attr('data-filter') === constants.FILTER_FREESHIPPING_CHECKBOX_NAME) {
            action = 'FilterFreeShipping';
            filterType = 'free-shipping';
        }
        
        TrackingUtil.throwFilterClickedEvent(filterType, filterValue);
        TrackingUtil.throwGAEvent(constants.TRACK_FILTER_USAGE, action, '', false);
    }
});
